/**
 * Adzuki.Time
 * Various time functions
 */

(function Time($, Adzuki)
{
	"use strict";

	var time = {};


	// round up to the nearest 15 minute increment
	time.next_fifteen = function next_fifteen(hour, minutes)
	{
		var nearest_fifteen = minutes,
		    output_hour     = hour,
		    output          = {};

		if (minutes === 0) {
			nearest_fifteen = '00';
		} else if ( (minutes >= 1) && (minutes <= 15) ) {
			nearest_fifteen = '15';
		} else if ( (minutes > 15) && (minutes <= 30) ) {
			nearest_fifteen = '30';
		} else if ( (minutes > 30) && (minutes <= 45) ) {
			nearest_fifteen = '45';
		} else if ( (minutes > 45) && (minutes <= 59) ) {
			output_hour     = (hour + 1);
			nearest_fifteen = '00';
		}

		output['hour']   = output_hour;
		output['minute'] = nearest_fifteen;

		return output;
	};


	Adzuki.Time = time;
}(jQuery, window.Adzuki || {}));
